module.exports = __webpack_public_path__ + "static/img/bg29.e190e53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg29.jpg
// module id = Ik+K
// module chunks = 1